document.addEventListener("DOMContentLoaded", () => {
  new Swiper("#cl-outer-swiper.swiper", {
    autoplay: {
      delay: 10000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    autoHeight: true,
    slidesPerView: 1,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      },
    },
  });

  new Swiper("#cl-shop-the-look #shop-the-look-swiper.swiper", {
    a11y: true,
    direction: "horizontal",
    centeredSlides: true,
    spaceBetween: 10,
    slidesPerView: 2.25,
    grabCursor: true,
    nested: true,
    mousewheel: {
      forceToAxis: true,
      enabled: true,
    },
    autoplay: {
      delay: 3500,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      480: {
        nested: false,
        slidesPerView: 3,
        centeredSlides: false,
      },
      640: {
        slidesPerView: 4,
      },
      768: {
        autoHeight: true,
        rewind: false,
        nested: false,
        slidesPerView: "auto",
        direction: "vertical",
        centeredSlides: false,
      },
    },
  });
});
